import { useState } from "react";
import { BusinessSetup, EventType, loadSetup, saveSetup, uid } from "./businessSetup";

export default function EventTypesCard() {
  const [setup, setSetup] = useState<BusinessSetup>(() => loadSetup());
  const [name, setName] = useState("");
  const [minutes, setMinutes] = useState("30");

  const persist = (next: BusinessSetup) => {
    saveSetup(next);
    setSetup(next);
  };

  const addType = () => {
    const length = Number(minutes);
    if (!name.trim() || !length || length < 5) return;
    const eventType: EventType = { id: uid(), name: name.trim(), minutes: length };
    persist({ ...setup, eventTypes: setup.eventTypes.concat(eventType) });
    setName("");
    setMinutes("30");
  };

  return (
    <div className="rounded-[20px] bg-white px-6 py-4 shadow-3xl shadow-shadow-500">
      <h3 className="text-sm font-bold text-navy-700">Event types for this business</h3>
      <p className="mt-1 text-xs text-gray-500">
        A gym can offer a trial. Another business can offer a demo. Create event uses the types you save here.
      </p>
      <ul className="mt-3 space-y-1">
        {setup.eventTypes.length === 0 ? <li className="text-xs text-gray-400">No custom event types yet.</li> : null}
        {setup.eventTypes.map((eventType) => (
          <li key={eventType.id} className="flex items-center justify-between text-sm text-navy-700">
            <span>{eventType.name} · {eventType.minutes} min</span>
            <button
              type="button"
              className="text-xs text-red-600"
              onClick={() => persist({ ...setup, eventTypes: setup.eventTypes.filter((item) => item.id !== eventType.id) })}
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <input
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="Trial, demo, consult"
          className="rounded-lg border border-gray-200 px-3 py-2 text-sm"
        />
        <input
          type="number"
          min={5}
          value={minutes}
          onChange={(event) => setMinutes(event.target.value)}
          aria-label="Minutes"
          className="w-24 rounded-lg border border-gray-200 px-3 py-2 text-sm"
        />
        <button type="button" onClick={addType} className="rounded-lg bg-green-600 px-3 py-2 text-sm font-medium text-white">
          Add event type
        </button>
      </div>
    </div>
  );
}
